
import { ChangeDetectionStrategy, Component, inject, OnInit, signal, input } from '@angular/core';
import { SharedModule } from '../../shared.module';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-icon',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SharedModule],
    template: '<img [src]="getIcon()" [alt]="getAlt()" [title]="getAlt()"/>',
    styleUrl: './icon.scss'
})
export class IconComponent implements OnInit {
  readonly kind = input.required<'AssignmentPickup' | 'AssignmentDelivery' | 'ReturnRentalOrder' | 'PickupRentalPurchasingOrder' | 'Confirmation' | ''>();

  readonly icon = signal('');
  readonly alt = signal('');

  ngOnInit() {
    this.icon.set(this.getIcon());
    this.alt.set(this.getAlt());
  }

  private translate = inject(TranslateService);

  getIcon() {
    const kind = this.kind();
    if (kind === 'AssignmentPickup') {
      return '../../../assets/icons/AssignmentPickup.svg';
    }

    if (kind === 'AssignmentDelivery') {
      return '../../../assets/icons/AssignmentDelivery.svg';
    }

    if (kind === 'ReturnRentalOrder') {
      return '../../../assets/icons/ReturnRentalOrder.svg';
    }

    if (kind === 'PickupRentalPurchasingOrder') {
      return '../../../assets/icons/PickupRentalPurchasingOrder.svg';
    }

    if (kind === 'Confirmation') {
      return '../../../assets/icons/CheckMark.svg';
    }

    return '';
  }

  getAlt() {
    const kind = this.kind();
    if (kind === 'AssignmentPickup') {
      return this.translate.instant('ICONS.ASSIGNMENT_PICKUP');
    }

    if (kind === 'AssignmentDelivery') {
      return this.translate.instant('ICONS.ASSIGNMENT_DELIVERY');
    }

    if (kind === 'ReturnRentalOrder') {
      return this.translate.instant('ICONS.ASSIGNMENT_RETURNRENTAL');
    }

    if (kind === 'PickupRentalPurchasingOrder') {
      return this.translate.instant('ICONS.ASSIGNMENT_PICKUPRENTAL');
    }

    if (kind === 'Confirmation') {
      return this.translate.instant('ICONS.CONFIRMATION');
    }

    return '';
  }
}
